// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button_wrapper[data-v-155173eb]{padding-top:0;padding-bottom:5rem;width:100%;background-color:#f5f7fa;display:flex;align-items:center;justify-content:center}@media (min-width:576px){.mobile_display[data-v-155173eb]{display:none}}@media (max-width:767.98px){.mobile_display[data-v-155173eb]{display:block}}@media (min-width:576px){.mobile_hide[data-v-155173eb]{display:block}}@media (max-width:767.98px){.mobile_hide[data-v-155173eb]{display:none}}", ""]);
// Exports
module.exports = exports;
